import { NextImage } from '@components/nextImage/NextImage';
import { ReactElement, useState } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { Caption, Container, ImageBox } from './Image.styles';
import { ImageProps } from './Image.types';
import style from './image.module.css';

export const Image = ({
  url,
  caption,
  alternativeText = '',
  objectFit = 'cover',
  containerAs = 'div',
  calculateWidth = false,
  originalSize = false,
}: ImageProps): ReactElement => {
  const [objectFitValue, setObjectFitValue] = useState(objectFit);

  // TODO replace getObjectFitValue after article content style update
  const getObjectFitValue = (e) => {
    if (!calculateWidth) {
      return;
    }

    const imageRatio = e.target.naturalWidth / e.target.naturalHeight;
    const isQuadratic = imageRatio <= 1;

    setObjectFitValue(isQuadratic ? 'contain' : 'cover');
  };

  const hasContainObjectFit = objectFitValue === 'contain';

  if (originalSize) {
    return (
      <Container as={containerAs} className={`${style.unsetimg} ${style.fullbleed}`}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <NextImage
          onLoad={getObjectFitValue}
          src={url}
          alt={alternativeText}
          className={style['custom-img']}
          title={caption}
          layout="fill"
        />
        {caption && <Caption reduceWidth={hasContainObjectFit}>{caption}</Caption>}
      </Container>
    );
  }
  return (
    <Container as={containerAs}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <NextImage
        onLoad={getObjectFitValue}
        src={url}
        alt={alternativeText}
        width={904}
        height={441}
        objectFit={objectFitValue}
        title={caption}
      />
      {caption && <Caption reduceWidth={hasContainObjectFit}>{caption}</Caption>}
    </Container>
  );
};

export const ImageWithLightBox = ({
  fullUrl,
  ...props
}: ImageProps & { fullUrl: string }): ReactElement => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <ImageBox onClick={() => setIsOpen(true)}>
        <Image {...props} />
      </ImageBox>

      {isOpen && <Lightbox mainSrc={fullUrl} onCloseRequest={() => setIsOpen(false)} />}
    </>
  );
};
